export enum EternoQuoteVariant {
    WARNING = '#4c726d',
    INFO = '#3b82f6',
    ERROR = '#ef4444',
}
